import { GeneralSetting } from '@apis'
import Button from '@components/button'
import Fields from '@components/fields'
import {
  StyleFormFieldWrapper,
  StyleFormRowWrapper,
} from '@components/fields/style'
import Row from '@components/row'
import { StyleColumn } from '@components/styles'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const AdminOfficeDetailForm = ({ officeDetail }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState({
    countryCode: '977',
    callCenterNo: '',
    email: '',
    location: '',
  })

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload: any = {
      key: 'officeDetail',
      value: JSON.stringify(values),
      title: 'Office Details',
    }

    if (!!officeDetail?.id) {
      await GeneralSetting.update('officeDetail', payload, officeDetail?.id)
        .then(() => {
          navigate('/admin/help-support')
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    } else {
      await GeneralSetting.create('officeDetail', payload)
        .then(() => {
          navigate('/admin/help-support')
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    }
  }
  useEffect(() => {
    if (!!officeDetail?.id) {
      const officeValue = !!officeDetail?.value
        ? JSON.parse(officeDetail?.value)
        : null
      setInitialValues({
        countryCode: officeValue?.countryCode,
        callCenterNo: officeValue?.callCenterNo,
        email: officeValue?.email,
        location: officeValue?.location,
      })
    } else {
      setInitialValues({
        countryCode: '',
        callCenterNo: '',
        email: '',
        location: '',
      })
    }
  }, [officeDetail?.id])

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={submitHandler}
      >
        {() => (
          <Form>
            <StyleColumn>
              <StyleFormRowWrapper>
                <StyleFormFieldWrapper>
                  <Fields.Input
                    name="email"
                    label="Email"
                    placeholder="Email"
                  />
                </StyleFormFieldWrapper>
                <StyleFormFieldWrapper>
                  <Fields.PhoneInput
                    name="callCenterNo"
                    label="Call Center No"
                    placeholder="Call Center No"
                  />
                </StyleFormFieldWrapper>
                <StyleFormFieldWrapper>
                  <Fields.Input
                    name="location"
                    label="Location"
                    placeholder="Enter Location"
                  />
                </StyleFormFieldWrapper>
              </StyleFormRowWrapper>
              <Row styleRow={{ marginLeft: 'auto' }}>
                <Button
                  type="submit"
                  title="Save"
                  height={40}
                  loading={loading}
                />
              </Row>
            </StyleColumn>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default AdminOfficeDetailForm
